
import React from "react";
import styles from "../assets/style.module.css";
import { ApiResponseData, BaseService, IProfileWebsite, ITeamHistory, OmneHostService, SanitizedResponse, Status } from "../../../../services";
import { Classname, Paginator, Scheme, useSearchParams } from "@rivtn/noseur";
import { Utils } from "../../../../utils";
import { i18nManager } from "../../../../i18n";

export interface TeamHistoryProps {
    website: IProfileWebsite;
}

function TeamHistory(props: TeamHistoryProps) {

    const { website } = props;
    const labels = i18nManager.Labels.gallery;
    const omnehostService = OmneHostService.getInstance();
    const [teamHistories, setTeamHistories] = React.useState<ApiResponseData<ITeamHistory>>();
    const { page, setPage } = useSearchParams({ defaultInit: window.location.search, params: { page: 1 } });

    React.useEffect(fetchInformation, [omnehostService, page]);

    return (<div className={styles["section"]}>
        <div className={styles["sec-line"]} />
        <h1 className={styles["sec-title"]}>Team <em>History</em></h1>
        <p className={styles["sec-sub"]}>Every club that shaped the legend</p>

        {(!!teamHistories?.content)
            ? ((teamHistories.content && teamHistories.content?.length > 0)
                ? (<div className={styles["team-cards"]}>
                    {teamHistories.content!.map((t) => {

                        return (<a key={t.external_id} className={Classname.build(styles["team-card"], styles["unlinked"])} target="_blank" href={`${window.location.origin}/te/${t.public_id}`}>
                            <div className={styles["team-logo-box"]} style={{ background: "var(--dark4)" }}>
                                <img style={{ width: 50, height: 50 }} alt={t.name} src={t.logo_url} />
                            </div>
                            <div>
                                <div className={styles["team-name-row"]}>
                                    <span className={styles["team-name"]}>{t.name}</span>
                                    {t.status === Status.ACTIVE && <span className={styles["current-badge"]}>Current</span>}
                                </div>
                                <div className={styles["team-period"]}>{new Date(t.join_date).getFullYear()} - {t.exit_date ? new Date(t.exit_date).getFullYear() : "Present"} · {i18nManager.queryCountryCurrency(t.country_code, "country_code", "country_name")}</div>
                                <div className={styles["team-achs"]}>
                                    {t.team_extra_data?.recent_achievements?.map((a: string) => <span key={a} className={styles["team-ach-tag"]}>{a}</span>)}
                                </div>
                            </div>
                            <div className={styles["team-nums"]}>
                                {(!!t.extra_data?.appearance_count) && (<div style={{ marginBottom: "0.5rem" }}>
                                    <span className={styles["tnum-val"]}>{t.extra_data?.appearance_count}</span>
                                    <span className={styles["tnum-lbl"]}>Apps</span>
                                </div>)}
                                {(!!t.extra_data?.appearance_won) && (<div>
                                    <span className={styles["tnum-val"]}>{t.extra_data?.appearance_won}</span>
                                    <span className={styles["tnum-lbl"]}>Goals</span>
                                </div>)}
                            </div>
                        </a>);
                    })}
                </div>)
                : (Utils.emptyState()))
            : (Utils.loadingState())}

        <Paginator scheme={Scheme.LIGHT} style={{ marginTop: 50 }} rowsPerPage={teamHistories?.size} totalRecords={teamHistories?.total_elements} initialPage={parseInt("" + page)} onPageChange={(e) => {
            setPage(e.currentPage)
        }} template={{
            activePageLabel: () => "",
            nextPageElement: (option) => (<button className={Classname.build(`${styles["page-btn"]}`, option.className, "fa fa-angle-right")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
            previousPageElement: (option) => (<button className={Classname.build(`${styles["page-btn"]}`, option.className, "fa fa-angle-left")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
            lastPageElement: (option) => (<button className={Classname.build(`${styles["page-btn"]}`, option.className, "fa fa-angle-double-right")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
            firstPageElement: (option) => (<button className={Classname.build(`${styles["page-btn"]}`, option.className, "fa fa-angle-double-left")} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick} />),
            pageElement: (option) => (<button className={Classname.build(`${styles["page-btn"]}`, option.className, (option.active ? styles["active"] : null))} style={{ margin: "0px 2.5px" }} disabled={option.disabled} onClick={option.onClick}>{option.label}</button>),
        }} />
    </div>);

    function fetchInformation() {
        setTeamHistories({});
        omnehostService.queryMemberTeamHistory(website.member.username, {
            page,
            sort: ["updated_at,ASC", "status,ASC"],
        }).then(({ apiResponse }: SanitizedResponse<ITeamHistory>) => {
            setTeamHistories(apiResponse.data!);
        }).catch(BaseService.reportError);
    }
}

export default TeamHistory;